<div class="e-group-row" role="row" #row tabindex="0">
    <div class="e-country-column">
        <span  matTooltipClass="e-mat-tooltip" matTooltipPosition="below"
        matTooltip="{{data.skuDetails.country}}" matTooltipShowDelay="500">{{data.skuDetails.countryCode}}</span>
    </div>
    <div class="e-sku-column" [class.e-sorted-by]="(config$ | async)?.viewBy ==='AcrossRetailers'">
        <div class="e-sku-details-container" (click)="getSkuCapsule(data.skuDetails.itemId)" role="button" aria-label="View SKU capsule details" tabindex="0">
            <div class="e-sku-thumbnail">
                <img [id]="data.skuDetails.name" [src]="blobStorageUrl + data.skuDetails.thumbnailUrl + imageSasParams" alt="SKU thumbnail"(error)="handleMissingImage(data.skuDetails.name)" />
            </div>
            <div class="e-sku-details">
                <h5 class="e-sku-name">{{data.skuDetails.name}}</h5>
                <span>
                    Category: {{data.skuDetails.category}}
                    <ng-container *ngIf="data.skuDetails.subCategory">| Sub-Category: {{data.skuDetails.subCategory}}</ng-container>
                </span>
                <span>Supplier: {{data.skuDetails.supplier}} | Brand: {{data.skuDetails.brand}}</span>
                <span>
                    <ng-container *ngIf="data.skuDetails.packSize">Pack Size: {{data.skuDetails.packSize}} |</ng-container>
                    Units per Pack: {{data.skuDetails.unitsPerPack}} |
                    Total Size: {{data.skuDetails.unitSize}}
                </span>
            </div>
        </div>
        <!-- TODO: Phase 2
        <mat-checkbox [checked]="data.isChecked"></mat-checkbox>
        <via-feedback-flag [feedbackReviewPending]="data.isReviewPending"></via-feedback-flag>
        -->
    </div>
    <div class="e-total-sku-size-column">
        <span *ngFor="let row of data.timeSeriesDataRows">
            {{data.skuDetails.unitSize}}
        </span>
    </div>
    <div class="e-retailer-column" *ngIf="(config$ | async)?.viewBy ==='Retailers'" [class.e-sorted-by]="selectedSortType === 'totalRetailers'">
        <span *ngFor="let row of data.timeSeriesDataRows">
            {{row.retailer.name}}
        </span>
    </div>
    <div class="e-time-series-column">
        <div *ngFor="let row of data.timeSeriesDataRows" class="e-time-series-grid-row"
            [class.e-show-prices]="isShowingAllPrices">
            <div *ngFor="let price of row.timeSeriesPrices | slice: timeSeriesIndices.start:timeSeriesIndices.end"
                [class]="price.noDataCollected ? 'e-no-data' : getCellClassName(price)"
                [ngStyle]="!price.noDataCollected && price.priceChangePercent !== 0 ? getCellStyles(price.priceChangePercent) : {}">
                <span *ngIf="!price.noDataCollected && !price.isOutOfStock && showRegularPrice">{{price.regularPrice | number: '1.2-2'}}</span>
                <span *ngIf="!price.noDataCollected && !price.isOutOfStock && !showRegularPrice">{{price.price | number: '1.2-2'}}</span>
            </div>
        </div>
    </div>
    <div class="e-sku-price-growth-column">
        <span *ngFor="let row of data.timeSeriesDataRows" matTooltipPosition="below"
        matTooltip={{getToolTipMessage(row.priceGrowthPercent)}} matTooltipShowDelay="500"
            [class]="getPriceGrowthClassName(row.priceGrowthPercent)">
            {{getPriceGrowthText(row.priceGrowthPercent)}}
        </span>
    </div>
</div>
